import "./styles.css";
import React from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import AddIcon from "@mui/icons-material/Add";

const CustomTable = ({
  tableKey,
  data = [],
  columns = [],
  showAddBtn = false,
  filteredData = [],
  addClass = () => {},
  handleAddRow = () => {},
  newRowsAddedData,
  handleHeaderInfo = () => {},
}) => {
  const onRowDragEnd = (event) => {
    const { api } = event;
    const visibleRows = [];

    api.forEachNode((node) => {
      visibleRows.push(node.data);
    });

    const updatedFullDataset = [...data];

    visibleRows.forEach((draggedRow, newIndex) => {
      const originalIndex = updatedFullDataset.findIndex(
        (row) => row.id === draggedRow.id
      );
      if (originalIndex !== -1) {
        updatedFullDataset.splice(originalIndex, 1);
        updatedFullDataset.splice(newIndex, 0, draggedRow);
      }
    });

    handleHeaderInfo(
      { key: "is_dragged", value: true },
      updatedFullDataset,
      tableKey
    );
  };

  const onFilterChanged = (params) => {
    params.api.forEachNode((node) => {
      node.setDataValue("drag", "");
    });

    params.api.refreshCells({
      columns: ["drag"],
      force: true,
    });
  };

  return (
    <>
      <div className="ag-theme-alpine custom-grid" style={{ width: "100%" }}>
        <AgGridReact
          className="ag-theme-alpine"
          rowData={filteredData}
          columnDefs={columns}
          getRowClass={(params) =>
            tableKey === "remediation_report" ? addClass(params) : ""
          }
          defaultColDef={{
            resizable: false,
            sortable: false,
            filter: false,
          }}
          //
          enableClipboard={true}
          enableRangeSelection={true}
          clipboardDelimiter={"\t"}
          copyHeadersToClipboard={true}
          //
          rowDragManaged={true}
          rowDragMultiRow={true}
          onFilterChanged={onFilterChanged}
          animateRows={true}
          singleClickEdit={true}
          stopEditingWhenCellsLoseFocus={true}
          suppressRowClickSelection={true}
          rowSelection="multiple"
          onRowDragEnd={onRowDragEnd}
          domLayout="autoHeight"
          enableFillHandle={true}
          localeText={{ noRowsToShow: "No data available" }}
          onGridReady={(params) => {
            params.api.refreshCells({ force: true });
          }}
        />
        {showAddBtn && (
          <button
            disabled={newRowsAddedData.length >= 10 ? true : false}
            onClick={() =>
              newRowsAddedData.length < 10 && handleAddRow(tableKey)
            }
            className="addRowBtn"
          >
            <AddIcon
              className="addrowicon"
              style={{ fontSize: "20px", color: "#04444D" }}
            />{" "}
            <span>Add New Row</span>
          </button>
        )}
      </div>
    </>
  );
};

export default CustomTable;
